module.exports = __webpack_public_path__ + "img/img_xinfeng.bc424585.png";